import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environment/environment';
import { APP_ID } from '../app-id';

export interface Provider {
  name: string;
  url: string;
  redirectUri: string;
  clientId: string;
  responseType: string;
  scope: string;
  scopeDelimiter: string;
  authorizationEndpoint: string;
  requiredUrlParams: string[];
  type: string;
}

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private http = inject(HttpClient);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getProviders(url: string): Observable<Provider[]> {
    const data = [
      {
        name: 'Comcast SSO',
        url: 'http://localhost/api/1/auth/ping',
        redirectUri: 'http://localhost/api/1/auth/ping',
        clientId: environment.oauthClientId,
        responseType: 'code',
        scope: 'openid%20profile%20email',
        scopeDelimiter: ' ',
        authorizationEndpoint: APP_ID.authorizationEndpoint,
        requiredUrlParams: ['scope'],
        type: '2.0',
      },
    ];
    return of(data);
  }

  getUserDetails(object: { URL: string; userId: string; partnerName: string }) {
    const tokenHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('encodeAzureID') ?? '',
      'x-xpki-source': 'gibbon',
      'x-xpki-tracking-id': `gibbon_getUserDetails`,
      'x-xpki-pn': `${object.partnerName}`,
    });
    const httpOptions = {
      headers: tokenHeaders,
    };
    return this.http.get(
      `${object.URL}?id=${object.userId}&p=${object.partnerName}`,
      httpOptions,
    );
  }

  getPartners(object: { URL: string; partnerName: string }) {
    const tokenHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('encodeAzureID') ?? '',
      'x-xpki-source': 'gibbon',
      'x-xpki-tracking-id': `gibbon_getPartner`,
      'x-xpki-pn': `${object.partnerName}`,
    });
    const httpOptions = {
      headers: tokenHeaders,
    };
    return this.http.get(`${object.URL}`, httpOptions);
  }
}
